module.exports = __webpack_public_path__ + "media/images/pc/top/hairstyle_header_bg@2x-ea934ccf7ba48a561f465cc4ce62961e.webp";